import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "./session";

/**
 * Route guard: every app shell (AppShell, FieldShell) renders inside this.
 * No token in localStorage → bounce to /login (the only public route).
 * Token expiry is handled separately in the API client (401 → clear + login).
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!getToken()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
